import React from 'react';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import { incomingItemMargin } from '../../../../utils/incomingItemMargin';
import { parseInventoryMoney } from '../../../../utils/inventoryInputs';
import { formatMarginPercent } from '../../../../utils/margin';
import '../../../../styles/incoming-item-margin.css';

const priceFormatter = new Intl.NumberFormat('uk-UA', {
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
});

function IncomingItemMargin({ retailPrice, purchasePrice, tooltipId }) {
  const sale = parseInventoryMoney(retailPrice);
  const cost = parseInventoryMoney(purchasePrice);
  const margin = incomingItemMargin(sale, cost);
  const percent = formatMarginPercent(margin?.percent);
  const tooltip = margin ? (
    <>
      <div>Роздрібна ціна без знижки: {priceFormatter.format(sale)} грн</div>
      <div>Ціна закупки: {priceFormatter.format(cost)} грн</div>
      <div>Різниця: {priceFormatter.format(margin.amount)} грн/шт.</div>
      <div>
        Маржа: ({priceFormatter.format(sale)} − {priceFormatter.format(cost)}) /{' '}
        {priceFormatter.format(sale)} × 100% = {percent}
      </div>
    </>
  ) : (
    'Потрібні ціна закупки та додатна роздрібна ціна з каталогу'
  );

  return (
    <OverlayTrigger
      placement='top'
      delay={0}
      transition={false}
      trigger={['hover', 'focus']}
      overlay={
        <Tooltip id={tooltipId} className='incoming-margin-tooltip'>
          {tooltip}
        </Tooltip>
      }
    >
      <span
        tabIndex={0}
        className={`incoming-margin-trigger ${
          margin
            ? `font-weight-bold ${margin.amount < 0 ? 'text-danger' : 'text-dark'}`
            : 'text-muted'
        }`}
      >
        {percent}
      </span>
    </OverlayTrigger>
  );
}

export default React.memo(IncomingItemMargin);
